/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditableField as SharedEditableField } from '@lumora/ui';

interface EditableFieldProps {
    contentKey: string;
    content: any;
    setContent: (updatedContent: any) => void;
    isEditMode: boolean;
    as?: any;
    className?: string;
    onSave?: (updatedContent: any) => void;
    useHtml?: boolean;
}

const editClasses = 'w-full bg-yellow-50 border-2 border-dashed border-red-500 focus:outline-none focus:ring-2 focus:ring-red-600 p-2 text-black transition-all';

/**
 * Keeps the site's `content[contentKey]` API but renders the shared @lumora/ui field.
 */
const EditableField = ({
    contentKey,
    content,
    setContent,
    isEditMode,
    as: Component = 'p',
    className = '',
    onSave,
    useHtml = false,
}: EditableFieldProps) => {
    const value = String(content[contentKey] ?? '');
    const longText = Component === 'textarea' || contentKey.toLowerCase().includes('text') || contentKey === 'description' || useHtml;

    return (
        <SharedEditableField
            value={value}
            label={contentKey}
            editable={isEditMode}
            as={Component}
            className={className}
            editClassName={`${editClasses} ${className}`}
            multiline={longText}
            richText={useHtml}
            rows={6}
            keepEmpty
            onCommit={(next) => {
                const updatedContent = { ...content, [contentKey]: next };
                setContent(updatedContent);
                if (onSave) onSave(updatedContent);
            }}
        />
    );
};

export default EditableField;
